import { createSelector } from 'reselect';
import getBooking from './getBooking';
import isBookingLoaded from './isBookingLoaded';

const selectIsPaymentPlanAvailable = createSelector(
  (state, bookingReference) => isBookingLoaded(state, bookingReference),
  (state, bookingReference) => getBooking(state, bookingReference),
  (loaded, booking) => {
    if (!loaded || !booking) {
      return false;
    }

    return booking?.payment_plan_available ?? false;
  },
);

export default selectIsPaymentPlanAvailable;
